import { JSX } from "react";
import { useLocation } from "react-router-dom";
import { NetworkIntegrityAggregateGroup, NetworkIntegrityAggregateKey } from "@app/projects/enumerators";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { NetworkIntegrityGenerateReportPanelBody } from "./NetworkIntegrityGenerateReportPanelBody";
import { NetworkIntegrityRouteState, RouteMatchParams } from "../models"; 
import { AccordionContainer } from "@app/shared/AccordionContainer";
import { Accordion } from "@app/shared/Accordion";

const getFileNameAggregateType = (aggregateType: string): string => {
  switch (aggregateType) {
    case NetworkIntegrityAggregateKey.DeactivatedNpi:
      return "Deactivated NPI";
    case NetworkIntegrityAggregateKey.InvalidNpi:
      return "Invalid NPI";
    case NetworkIntegrityAggregateKey.MedicarePrecluded:
      return "Medicare Preclusion";
    case NetworkIntegrityAggregateKey.MissingNpi:
      return "Missing NPI";
    case NetworkIntegrityAggregateGroup.AttestationBasedAlerts:
      return "Attestation-based Alerts";
    case NetworkIntegrityAggregateGroup.AllExcessWarnings:
      return "Excess Warnings"
    case NetworkIntegrityAggregateGroup.ExcessAddresses:
      return "Excess Addresses"
    case NetworkIntegrityAggregateGroup.ExcessSpecialties:
      return "Excess Specialties";
    case NetworkIntegrityAggregateGroup.CriticalAlerts:
      return "Critical Alerts";
    case NetworkIntegrityAggregateGroup.OptionalExclusions:
      return "Project Option Exclusions";
    default:
      return aggregateType;
  };
}

const getAllOrSelected = (locationState: NetworkIntegrityRouteState): string => {
  let allOrSelected = (locationState.selectedKeys && locationState.selectedKeys.length > 0) ? "Selected" : "All";
  
  if (locationState.selectedProviderAndProviderSetVersionIds && locationState.selectedProviderAndProviderSetVersionIds.length > 0) {
    allOrSelected = "Selected";
  }

  return allOrSelected;
}

const NetworkIntegrityGenerateReportPanel = (props: RouteMatchParams): JSX.Element => {
  const {aggregateGroup, providerType} = props;
  // React Router v5 does not decode reserved characters (e.g. `&` survives as `%26`) in path params,
  // and the upstream caller passes these route params straight through. Decode once here so the
  // panel title renders cleanly AND the body's export request body carries the canonical value.
  const aggregateType = props.aggregateType ? decodeURIComponent(props.aggregateType) : props.aggregateType;
  const decodedProps: RouteMatchParams = { ...props, aggregateType };
  const locationState = useLocation<NetworkIntegrityRouteState>().state;
  const allOrSelected = getAllOrSelected(locationState);
  const userMdIcon = <QesIcon isDecorative iconName={QesIcons.UserV1} width="14" height="14" className="align-baseline me-1" style={{ position: "relative", top: "1px" }} />;
  const panelTitle = <>{userMdIcon} Provider Detail - {allOrSelected} {providerType} Providers By  {getFileNameAggregateType(aggregateType ?? aggregateGroup)}</>;
  return (
      <AccordionContainer>
        <Accordion
        testId="network-integrity-generate-report-panel_accordion"
        title={panelTitle}
        defaultOpen={true}>

        <NetworkIntegrityGenerateReportPanelBody {...decodedProps} />
        </Accordion>
      </AccordionContainer>
  )
}

export { NetworkIntegrityGenerateReportPanel };